import {
  FacebookColor,
  InstagramColor,
  NaverColor,
  ThreadsColor,
  ViewupPlusColor,
  YoutubeColor,
} from '@viewup/ui';
import { SnsEarnViewingBehavior, type SnsTypes } from '../types';

export const SNS_ACTIVITY_EARN_VIEWING_LABEL = {
  [SnsEarnViewingBehavior.Click]: '클릭뷰업',
  [SnsEarnViewingBehavior.Posting]: '포스팅뷰업',
};

export const exchangeSnsIcon = (type: SnsTypes) => {
  const iconMap = {
    facebook: FacebookColor,
    instagram: InstagramColor,
    nblog: NaverColor,
    threads: ThreadsColor,
    viewupPlus: ViewupPlusColor,
    youtube: YoutubeColor,
  };
  const icon = iconMap[type] || iconMap.viewupPlus;
  return icon;
};

export const ACCOUNT_ACTIVE_CHIP = {
  facebook: ['click'],
  instagram: ['click'],
  nblog: ['click', 'posting'],
  threads: ['click'],
  youtube: ['click'],
};
